module.exports = __webpack_public_path__ + "media/application/images/svgs/pocket-b84b8c9d6ba40ae3603684adc1e94c0e.svg";